import HeroSection from "./components/HeroSection";
import {FAQCard, genFAQs} from "../../landing-page/components/FAQs";

export default function HelpIndex({className, ...props}) {
    const fags = {
        "Frequently Asked Questions": genFAQs()
    }

    return (
        <div className={` ${className}`}>
            <HeroSection/>
            <div className={"flex flex-col w-full justify-center items-center"}>
                <div className={"w-full lg:w-4/5 py-4 lg:py-10 px-8 lg:px-16"}>
                    {
                        Object.keys(fags).map((key, index2) => {
                            return (
                                <div className={""} key={index2}>
                                    <p className={"text-xl font-bold"}>
                                        {key}
                                    </p>
                                    <div className={"grid mt-4  lg:mt-8 grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-8"}>
                                        {
                                            fags[key].map((item, index) => {

                                                return (
                                                    <div className={"col-span-1"}>
                                                        <FAQCard {...item} />
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                            )
                        })
                    }


                </div>
            </div>
        </div>

    )
}